import { parse, isValid, format, endOfMonth } from 'date-fns'
import type { Patient, PatientWithOptionalId } from '../../types'

export type CreatePatientRequest = Omit<Patient, 'id'>

export type BatchCreatePatientsResponseItem = {
  data: {
    id: string
  } | null
  error: {
    reason: any
  } | null
}

export const emptyPatient: PatientWithOptionalId = {
  given_names: '',
  family_name: '',
  gender: 'N',
  date_of_birth: '',
  ihi_number: '',
  ihi_status: '',
  record_status: '',
  entitlement_no: '',
  ctg_flag: false,
  hospital_category: false,
  pbs_entitlement_no: '',
  pbs_safety_net_entitlement_card_holder: false,
  pbs_concession_card_holder: false,
  email: '',
  phone_number: '',
  state: '',
  suburb: '',
  address_1: '',
  address_2: '',
  postcode: 0,
  medicare_no: '',
  medicare_irn: '',
  medicare_valid_to: '',
  dva_file_no: '',
  dva_card_colour: '',
  concession_pension_no: '',
  atsi_status: '',
  paper_only: false,
}

export const transformPatientRequestPayload = <T>(data: Patient | CreatePatientRequest): T => {
  const { medicare_valid_to } = data
  if (medicare_valid_to && medicare_valid_to.match(/^\d{4}-\d{2}$/)) {
    const fullDate = medicare_valid_to + '-01'
    const parsedDate = parse(fullDate || '', 'yyyy-MM-dd', new Date())
    data.medicare_valid_to = isValid(parsedDate)
      ? format(endOfMonth(parsedDate), 'yyyy-MM-dd')
      : medicare_valid_to
  }

  return data as unknown as T
}
